<h2 mat-dialog-title>Are you sure you want to edit this transformation definition?</h2>
<mat-dialog-content class="w-100 flex-row justify-end">
  <div class="pb-3">The following definitions are tied to this transformation:</div>
  @for (group of dependantGroups; track group.type) {
    <div class="pt-2 text-muted">{{group.label}}</div>
    @for (dependant of group.dependants; track dependant.id) {
      <div>
        <span class="text-bold">{{dependant?.name}}</span>@if (group.type=='md') { ({{dependant.configurationsCount ?? 0}} configurations)}
      </div>
    }
  }
  <div class="pt-3">
    Any changes to this transformation will impact these definitions<br> and you must ensure that they are updated accordingly.
  </div>
</mat-dialog-content>

<mat-dialog-actions >
  <div class="w-100 flex-row justify-end items-center mt-3 p-2">
    <a mat-button class="dialog-btn mr-5" color="primary" (click)="onCancelClick()" ><span class="text-bold">{{cancelButtonText}}</span></a>
    <a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()"><span class="text-bold">{{confirmButtonText}}</span></a>
  </div>
</mat-dialog-actions>